export const routes = {
    HOME: '/',
    AUTH_LOGIN: "/auth/login",
    AUTH_SIGNUP: "/auth/signup",
    AUTH_RESET: "/auth/reset",
    AUTH_MFA: "/auth/mfa",
    DASHBOARD: "/dashboard",
    PAYLINKS: "/paylinks",
    PAYLINKS_ACTIVITY: "/paylinks/activities",
    TRANSACTIONS: "/transactions",
    BALANCE: "/balance",
    WITHDRAWAL_DETAIL: "/balance/withdrawal",
    API: "/apikeys",
}